import { render, staticRenderFns } from "./AfterSalesBtn.vue?vue&type=template&id=4ed8374a&scoped=true&"
import script from "./AfterSalesBtn.vue?vue&type=script&lang=js&"
export * from "./AfterSalesBtn.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesBtn.vue?vue&type=style&index=0&id=4ed8374a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8374a",
  null
  
)

export default component.exports